import { types } from 'mobx-state-tree';


const SECTOR_TYPES = {
    OTHER: 'other',
    CONSTRUCTION: 'construction',
    SERVICES: 'services',
    MANUFACTURING: 'manufacturing',
    FARMING_AND_NATURAL_RESOURCES: 'farming-natural-resources',
    VARIES: 'varies',
    GOVERNMENT: 'government',
    HEALTH: 'health',
    EDUCATION: 'education',
    HIGH_TECH: 'hightech',
    RETAIL: 'retail-sales',
    LEISURE_AND_ENTERTAINMENT: 'leisure-entertainment',
    BANKING_AND_FINANCE: 'banking-finance',
    TRANSPORTATION: 'transportation',
};

const SectorTypeEnum = types.enumeration('SectorType', Object.values(SECTOR_TYPES));

export {
    SectorTypeEnum,
};
export default SECTOR_TYPES;
